module.exports = "/assets/data/efbed297abd6e733b52523afd9c49f70-CM2.data.json";